'use client';

import { useEffect } from 'react';

type OwnProps = {
  data: Record<string, unknown>;
  name: string;
};

export default function DebugServerLogger({ data, name }: OwnProps) {
  useEffect(() => {
    console.log(`[debug] ${name}`, data);
  }, [data, name]);

  return null;
}
